import { IPhoto } from 'models/api';

import { IProfilePhotoData } from 'services/api/profile/profileService';
import { IConverter } from 'services/api/types';

export const profileConverter: IConverter<IProfilePhotoData[], IPhoto[]> = {
  convert(data) {
    const profile = data[0];

    if (!profile) {
      return [];
    }

    return [profile.mainPhoto, ...profile.photos];
  },
};
